export type FabAction = {
  id: 'new-mission' | 'eval' | 'chiffrage' | 'new-quote' | 'new-note';
  label: string;
  description: string;
  to: string;
  icon: string;
};

// LOT 5.1 — le menu affiche des intentions, pas des implémentations : plus
// de "Wizard" ni de nom technique (voir docs/HUB-LOT5.1-PARCOURS-UNIQUE.md,
// Phase G). "Nouvelle mission" est l'unique point d'entrée de création ;
// "Évaluer une opportunité" reste une fonction distincte (GO/NO-GO).
// Isolé de FabMenu.tsx pour rester importable sans déclencher le store
// applicatif (`@shared/state` s'évalue à l'import — voir le pattern déjà
// utilisé pour newMissionWizardLogic.ts).
export const FAB_OPTIONS: FabAction[] = [
  { id: 'new-mission', label: 'Nouvelle mission',  description: 'Création rapide',            to: '/missions/new',         icon: '🤝' },
  { id: 'eval',        label: 'Évaluer une opportunité', description: 'GO / NO-GO avant de vous engager', to: '/tools/eval', icon: '🧭' },
  { id: 'chiffrage',   label: 'Chiffrer une mission', description: 'Estimer jours, TJM, budget', to: '/tools/calc-mission', icon: '🧮' },
  { id: 'new-quote',   label: 'Créer un devis',    description: 'Préparer une offre',         to: '/new-document?kind=devis', icon: '🧾' },
  { id: 'new-note',    label: 'Prendre une note',  description: 'Notes cross-missions',       to: '/tools/notes',          icon: '📝' },
];

/**
 * Sous-ensemble affiché dans la feuille "Créer" mobile (MOB-012, fondation
 * mobile Lot 1) : au maximum 4 actions, uniquement celles qui pointent vers
 * une route déjà existante (dérivé de `FAB_OPTIONS`, aucune route inventée).
 * "Évaluer une opportunité" est omise ici : depuis MOB-011, Opportunités a
 * sa propre destination dans la barre mobile, donc la feuille de création se
 * limite aux actes de création au sens strict.
 */
const MOBILE_CREATE_ACTION_IDS: ReadonlyArray<FabAction['id']> = ['new-mission', 'chiffrage', 'new-quote', 'new-note'];

export const MOBILE_CREATE_ACTIONS: FabAction[] = FAB_OPTIONS.filter((option) =>
  MOBILE_CREATE_ACTION_IDS.includes(option.id),
);
